import { gql } from "@apollo/client";

const CREATE_TEAM = gql`
  mutation createTeam(
    $title: String
    $country: String
    $status: String
    $sport: Int
    $club: Int
    $members: [JSONObject!]
    $discipline: Int
    $image: Upload
    $platform: Int
    $phone: String
    $email: String
    $website: String
    $instagramLink: String
    $facebookLink: String
    $twitterLink: String
    $tiktokLink: String
    $joinedFrom: String
  ) {
    createTeam(
      createTeamInput: {
        title: $title
        country: $country
        status: $status
        sport: $sport
        club: $club
        members: $members
        discipline: $discipline
        image: $image
        platform: $platform
        phone: $phone
        email: $email
        website: $website
        instagramLink: $instagramLink
        facebookLink: $facebookLink
        twitterLink: $twitterLink
        tiktokLink: $tiktokLink
        joinedFrom: $joinedFrom
      }
    ) {
      id
      title
      status
      country
    }
  }
`;

export default CREATE_TEAM;
